import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly _showFrameworkMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private readonly _showHubMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private readonly _selectedApp: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private readonly _reloadNexus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private readonly _showHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() {
    this.setSelectedApp(localStorage.getItem('app-selected') ?? '')
  }

  reloadNexus() {
    this._reloadNexus.next(true);
  }

  get reloadNexus$() {
    return this._reloadNexus;
  }

  public get showFrameworkMenu(): boolean {
    return this._showFrameworkMenu.value;
  }

  public enableFrameworkMenu(): void {
    this._showFrameworkMenu.next(true);
  }

  public disableFrameworkMenu(): void {
    this._showFrameworkMenu.next(false);
  }

  public get showHubMenu(): boolean {
    return this._showHubMenu.value;
  }

  public enableHubMenu(): void {
    this._showHubMenu.next(true);
  }

  public disableHubMenu(): void {
    this._showHubMenu.next(false);
  }

  public get showHeader(): boolean {
    return this._showHeader.value;
  }

  public enableHeader(): void {
    this._showHeader.next(true);
  }

  public disableHeader(): void {
    this._showHeader.next(false);
  }

  public get selectedApp(): string {
    return this._selectedApp.value;
  }

  public get selectedApp$(): BehaviorSubject<string> {
    return this._selectedApp;
  }

  public setSelectedApp(app: string): void {
    localStorage.setItem('app-selected', app);
    this._selectedApp.next(app);
  }
}
